import React, { useContext, useEffect } from "react"

import { Phase } from "../../types.ts"
import { OrderContext } from "../../OrderContext.tsx"
import { filledb2bOrder } from "../../data.ts"
import PhaseOne from "./PhaseOne.tsx"
import PhaseTwo from "./PhaseTwo.tsx"
import PhaseThree from "./PhaseThree.tsx"
import PhaseFour from "./PhaseFour.tsx"
import PhaseFive from "./PhaseFive.tsx"
import { useTranslation } from "react-i18next"

function B2B({ currentPhase }: { currentPhase: Phase }) {
  const { setFormValues } = useContext(OrderContext);
  const { t } = useTranslation();

  useEffect(() => {
    // prefillData();
  }, [])

  const prefillData = () => {
    setFormValues(filledb2bOrder)
  }

  return (
    <>
      {currentPhase.value === 'kohde' && (
        <PhaseOne />
      )}

      {currentPhase.value === 'sopimus' && (
        <PhaseTwo />
      )}

      {currentPhase.value === 'palvelut' && (
        <PhaseThree />
      )}

      {currentPhase.value === 'asiakastiedot' && (
        <PhaseFour />
      )}

      {currentPhase.value === 'yhteenveto' && (
        <PhaseFive />
      )}
    </>
  );
}

export default B2B;
